module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-brand",
    on: {
      "click": function($event) {
        _vm.goTo('/')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/coches-small-black.png"),
      "alt": "Museu Nacional dos Coches"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }), _vm._v(" "), _c('span', {
    staticClass: "nav-toggle",
    on: {
      "click": function($event) {
        _vm.showNavMenu = !_vm.showNavMenu
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu",
    class: {
      'is-active': _vm.showNavMenu
    }
  }, [_c('a', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.goTo('/')
      }
    }
  }, [_vm._v("\n      Coches\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item",
    on: {
      "click": function($event) {
        _vm.goTo('/users')
      }
    }
  }, [_vm._v("\n      Utilizadores\n    ")]), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": "Logout",
      "placement": "bottom"
    }
  }, [_c('span', {
    staticClass: "nav-item logout-btn"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.username))])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45e7c1ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/NavBar.vue
// module id = 317
// module chunks = 1